/**
 * Applies readonly attribute to cells regarding options.
 * 
 * @param {any} row
 * @param {any} col
 * @param {any} cell
 * @param {any} prop
 * @param {any} table
 * @param {any} cellProperties
 */
export default function (row, col, cell, prop, table, cellProperties) {
    const readOnlyRows = table.readOnlyRows;

    if (readOnlyRows !== undefined && readOnlyRows !== null && readOnlyRows.includes(row)) {
        cellProperties.readOnly = true;
        return;
    }

    const cells = table.cell;
    if (!!cells) {
        const cell = cells.find(x => x.row === row && x.col === col);
        if (!!cell && cell.readOnly === true) {
            cellProperties.readOnly = true;
            return;
        }
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/cellprocessors/readOnlyProcessor.js